import { type TourProduct, getTourConfirmationType } from '@entities/tourProduct';
import { ConfirmationType } from '@entities/confirmationType';

export default function (tourProduct: TourProduct, takenConfirmations: ConfirmationType[]): boolean {
    if (!takenConfirmations.length) return true;
    const tourConfirmationType = getTourConfirmationType(tourProduct);

    if (takenConfirmations.includes(ConfirmationType.Quick) && takenConfirmations.length === 1) return tourConfirmationType ===  ConfirmationType.Quick;

    if (takenConfirmations.includes(ConfirmationType.Long)) return tourConfirmationType === ConfirmationType.Quick || tourConfirmationType === ConfirmationType.Long;

    return false;
}